// extracted by mini-css-extract-plugin
export default {"base":"Navigation_base__iZsUc","items":"Navigation_items__XIVu4"};